import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PLAYROOM_ACHIEVEMENTS_SECTION_KEY } from "../constants";
var en = /*#__PURE__*/_defineProperty({}, PLAYROOM_ACHIEVEMENTS_SECTION_KEY, {
  PAS_TITLE: 'Badges',
  PAS_DESCRIPTION: 'Discover your earned badges or the ones you can unlock during your learning journey.',
  PAS_GOTO_MY_COURSES: 'Go to my courses',
  PAS_HELP_SECTION_TITLE: 'How do I earn points once I have obtained the badges?',
  PAS_ERROR_VIEW_TITLE: 'Data failed to load correctly',
  PAS_ERROR_VIEW_DESCRIPTION: 'Please reload the page'
});
export default en;